import * as z from 'zod';

export const CreateBrandRequest = z.object({
  brand: z
    .object({
      _id: z
        .string()
        .describe('Brand ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the brand was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the brand was updated.')
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Brand name.\n>**Note:** `name` must be unique.')
        .min(1)
        .max(50),
      assignedProductsCount: z
        .number()
        .int()
        .describe(
          'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
        )
        .optional()
        .nullable(),
    })
    .describe('Brand to create.'),
});
export const CreateBrandResponse = z.object({
  _id: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the brand was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the brand was updated.')
    .optional()
    .nullable(),
  name: z
    .string()
    .describe('Brand name.\n>**Note:** `name` must be unique.')
    .min(1)
    .max(50)
    .optional(),
  assignedProductsCount: z
    .number()
    .int()
    .describe(
      'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
    )
    .optional()
    .nullable(),
});
export const GetBrandRequest = z.object({
  brandId: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const GetBrandResponse = z.object({
  _id: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the brand was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the brand was updated.')
    .optional()
    .nullable(),
  name: z
    .string()
    .describe('Brand name.\n>**Note:** `name` must be unique.')
    .min(1)
    .max(50)
    .optional(),
  assignedProductsCount: z
    .number()
    .int()
    .describe(
      'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
    )
    .optional()
    .nullable(),
});
export const UpdateBrandRequest = z.object({
  _id: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  brand: z
    .object({
      _id: z
        .string()
        .describe('Brand ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
        ),
      _createdDate: z
        .date()
        .describe('Date and time the brand was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the brand was updated.')
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Brand name.\n>**Note:** `name` must be unique.')
        .min(1)
        .max(50)
        .optional(),
      assignedProductsCount: z
        .number()
        .int()
        .describe(
          'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
        )
        .optional()
        .nullable(),
    })
    .describe('Brand to update.'),
  options: z
    .object({
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const UpdateBrandResponse = z.object({
  _id: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the brand was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the brand was updated.')
    .optional()
    .nullable(),
  name: z
    .string()
    .describe('Brand name.\n>**Note:** `name` must be unique.')
    .min(1)
    .max(50)
    .optional(),
  assignedProductsCount: z
    .number()
    .int()
    .describe(
      'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
    )
    .optional()
    .nullable(),
});
export const DeleteBrandRequest = z.object({
  brandId: z
    .string()
    .describe('Brand ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteBrandResponse = z.object({});
export const QueryBrandsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _createdDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          name: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum(['_createdDate', '_updatedDate', 'name'])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe('Query options.'),
  options: z
    .object({
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const QueryBrandsResponse = z.object({
  brands: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Brand ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the brand was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the brand was updated.')
          .optional()
          .nullable(),
        name: z
          .string()
          .describe('Brand name.\n>**Note:** `name` must be unique.')
          .min(1)
          .max(50)
          .optional(),
        assignedProductsCount: z
          .number()
          .int()
          .describe(
            'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
          )
          .optional()
          .nullable(),
      })
    )
    .min(1)
    .max(300)
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Paging metadata.')
    .optional(),
});
export const BulkCreateBrandsRequest = z.object({
  brands: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Brand ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the brand was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the brand was updated.')
          .optional()
          .nullable(),
        name: z
          .string()
          .describe('Brand name.\n>**Note:** `name` must be unique.')
          .min(1)
          .max(50),
        assignedProductsCount: z
          .number()
          .int()
          .describe(
            'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
          )
          .optional()
          .nullable(),
      })
    )
    .min(1)
    .max(100),
  options: z
    .object({
      returnEntity: z
        .boolean()
        .describe(
          'Whether to return the full created brand entities in the response.\n\nDefault: `false`'
        )
        .optional(),
    })
    .optional(),
});
export const BulkCreateBrandsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Bulk action metadata for brand.')
          .optional(),
        item: z
          .object({
            _id: z
              .string()
              .describe('Brand ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the brand was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the brand was updated.')
              .optional()
              .nullable(),
            name: z
              .string()
              .describe('Brand name.\n>**Note:** `name` must be unique.')
              .min(1)
              .max(50)
              .optional(),
            assignedProductsCount: z
              .number()
              .int()
              .describe(
                'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
              )
              .optional()
              .nullable(),
          })
          .describe(
            'Full brand entity.\n\nReturned only if `returnEntity: true` is passed in the request.'
          )
          .optional(),
      })
    )
    .max(100)
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Bulk action metadata.')
    .optional(),
});
export const BulkUpdateBrandsRequest = z.object({
  brands: z
    .array(
      z.object({
        brand: z
          .object({
            _id: z
              .string()
              .describe('Brand ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
              ),
            _createdDate: z
              .date()
              .describe('Date and time the brand was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the brand was updated.')
              .optional()
              .nullable(),
            name: z
              .string()
              .describe('Brand name.\n>**Note:** `name` must be unique.')
              .min(1)
              .max(50)
              .optional(),
            assignedProductsCount: z
              .number()
              .int()
              .describe(
                'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
              )
              .optional()
              .nullable(),
          })
          .describe('Brand to update.')
          .optional(),
        fieldMask: z.array(z.string()).optional(),
      })
    )
    .min(1)
    .max(100),
  options: z
    .object({
      returnEntity: z
        .boolean()
        .describe(
          'Whether to return the full updated brand entities in the response.\n\nDefault: `false`'
        )
        .optional(),
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const BulkUpdateBrandsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Bulk action metadata for brand.')
          .optional(),
        item: z
          .object({
            _id: z
              .string()
              .describe('Brand ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the brand was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the brand was updated.')
              .optional()
              .nullable(),
            name: z
              .string()
              .describe('Brand name.\n>**Note:** `name` must be unique.')
              .min(1)
              .max(50)
              .optional(),
            assignedProductsCount: z
              .number()
              .int()
              .describe(
                'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
              )
              .optional()
              .nullable(),
          })
          .describe(
            'Full brand entity.\n\nReturned only if `returnEntity: true` is passed in the request.'
          )
          .optional(),
      })
    )
    .max(100)
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Bulk action metadata.')
    .optional(),
});
export const GetOrCreateBrandRequest = z.object({
  brandName: z
    .string()
    .describe('Brand name to retrieve or create.')
    .min(1)
    .max(50),
  options: z
    .object({
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const GetOrCreateBrandResponse = z.object({
  brand: z
    .object({
      _id: z
        .string()
        .describe('Brand ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the brand was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the brand was updated.')
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Brand name.\n>**Note:** `name` must be unique.')
        .min(1)
        .max(50)
        .optional(),
      assignedProductsCount: z
        .number()
        .int()
        .describe(
          'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
        )
        .optional()
        .nullable(),
    })
    .describe('Brand.')
    .optional(),
});
export const BulkGetOrCreateBrandsRequest = z.object({
  brandNames: z.array(z.string()).min(1).max(100),
  options: z
    .object({
      fields: z
        .array(z.enum(['ASSIGNED_PRODUCTS_COUNT']))
        .max(100)
        .optional(),
    })
    .optional(),
});
export const BulkGetOrCreateBrandsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Bulk action metadata for brand.')
          .optional(),
        item: z
          .object({
            _id: z
              .string()
              .describe('Brand ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the brand is updated.\nTo prevent conflicting changes,\nthe current revision must be passed when updating the brand.\n\nIgnored when creating a brand.'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the brand was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the brand was updated.')
              .optional()
              .nullable(),
            name: z
              .string()
              .describe('Brand name.\n>**Note:** `name` must be unique.')
              .min(1)
              .max(50)
              .optional(),
            assignedProductsCount: z
              .number()
              .int()
              .describe(
                'Number of products this brand is assigned to.\n> **Note:** Returned only when you pass `"ASSIGNED_PRODUCTS_COUNT"` to the `fields` array in Brand API requests.'
              )
              .optional()
              .nullable(),
          })
          .describe(
            'Full brand entity.\n\nReturned only if `returnEntity: true` is passed in the request.'
          )
          .optional(),
      })
    )
    .max(100)
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Bulk action metadata.')
    .optional(),
});
export const BulkDeleteBrandsRequest = z.object({
  brandIds: z.array(z.string()).min(1).max(100),
});
export const BulkDeleteBrandsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Bulk action metadata for brand.')
          .optional(),
      })
    )
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Bulk action metadata.')
    .optional(),
});
